import {
  blackListCategoryNames,
  blackListKeysConversionKeys
} from '../../../../main/blacklistHelpers'
import Column from '../../Column/index'

const DetailsColumn = ({ name, conversion, lengths, children, isFullWidth }) => {
  function getSubtitle(name) {
    if (name === 'rateCodeStartsWith') {
      return `Any code starts with ${conversion.convertedRateCode.substring(
        0,
        lengths.rateCodeStartsWith
      )}`
    }

    if (name === 'trackingInfoStartingWith') {
      return `Any code starts with ${conversion.convertedTrackingCode.substring(
        0,
        lengths.trackingInfoStartingWith
      )}`
    }

    return conversion[blackListKeysConversionKeys[name]]
  }

  return (
    <Column
      title={blackListCategoryNames[name]}
      subtitle={getSubtitle(name)}
      isFullWidth={isFullWidth}
    >
      {children}
    </Column>
  )
}

export default DetailsColumn
